import { defineMessages } from 'react-intl';

export default defineMessages({
  priorityLabel: {
    id: 'template.priority',
    description: 'priority',
    defaultMessage: 'priority',
  },
});
